export default function Summary() {
  const scrollToPurchase = () => {
    const purchaseSection = document.getElementById('purchase-section');
    if (purchaseSection) {
      purchaseSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-24 bg-gradient-to-br from-[#6B4E9C] to-[#5A3D8B] text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            한 잔의 포도즙에는<br />6가지 정성이 담깁니다.
          </h2>
          <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
            마시면 바로 느껴지는 신선한 맛과 진한 풍미를 목표로 합니다.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
          {/* 1. 약품을 쓰지 않는 재배 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/15 transition-colors">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full mb-4">
              <i className="ri-plant-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold mb-2">약품을 쓰지 않는 재배</h3>
            <p className="text-white/80 text-sm">자연 그대로 키웁니다</p>
          </div>

          {/* 2. 천연 유기 퇴비 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/15 transition-colors">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full mb-4">
              <i className="ri-leaf-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold mb-2">천연 유기 퇴비</h3>
            <p className="text-white/80 text-sm">땅의 힘을 믿습니다</p>
          </div>

          {/* 3. 청정 암반수 세척 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/15 transition-colors">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full mb-4">
              <i className="ri-drop-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold mb-2">청정 암반수 세척</h3>
            <p className="text-white/80 text-sm">깨끗함의 시작</p>
          </div>

          {/* 4. 고당도 포도 선별 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/15 transition-colors">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full mb-4">
              <i className="ri-star-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold mb-2">고당도 포도 선별</h3>
            <p className="text-white/80 text-sm">최고의 원료만</p>
          </div>

          {/* 5. 저온 착즙 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/15 transition-colors">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full mb-4">
              <i className="ri-temp-cold-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold mb-2">저온 착즙</h3>
            <p className="text-white/80 text-sm">맛의 결을 지킵니다</p>
          </div>

          {/* 6. 고성능 착즙 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/15 transition-colors">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full mb-4">
              <i className="ri-flask-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold mb-2">고성능 착즙</h3>
            <p className="text-white/80 text-sm">풍미를 온전히</p>
          </div>
        </div>

        <div className="text-center mt-16 space-y-8">
          <p className="text-2xl font-semibold text-white/95 leading-relaxed">
            설명보다 강력한 것은 한 모금의 경험입니다.<br />
            저희의 모든 노력은 그 순간을 위해 설계됩니다.
          </p>

          <div className="pt-8">
            <p className="text-xl text-white/90 mb-6 leading-relaxed">
              원료의 정직함과 공정의 일관성이 한 병에 담깁니다.<br />
              포도즙은 결국 원료와 공정이 품질을 결정합니다.<br />
              저희는 그 기준을 끝까지 유지합니다.
            </p>
          </div>

          <div className="pt-8">
            <p className="text-2xl font-bold text-white mb-8">
              가장 기본을 가장 철저하게 지켰기에<br />자신 있게 권합니다.
            </p>
            <button 
              onClick={scrollToPurchase}
              className="bg-white text-[#6B4E9C] px-12 py-5 rounded-xl font-bold text-xl hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap shadow-xl"
            >
              화악산 포도즙 구매하기
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
